import {
  LOTTERY_SET_RENDER_TYPE
} from 'Store/constants';

const initialState = {
  isWebView: false
};

export default (state = initialState, action) => {
  switch (action.type) {
    case LOTTERY_SET_RENDER_TYPE:
      return { ...state, isWebView: true };
    default:
      return state;
  }
};
